import { render, staticRenderFns } from "./ReviewBigQueryHarvester.vue?vue&type=template&id=0ca1efec&"
import script from "./ReviewBigQueryHarvester.vue?vue&type=script&lang=ts&"
export * from "./ReviewBigQueryHarvester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports